module.exports = __webpack_public_path__ + "static/img/preparation.ffb52df2.png";